import React, { useMemo } from "react";
import { useAppSelector } from "../../../../store/configureStore";

import ConcreteHammerReportPDF from "../concrete-hammer-report";
import Conditional from "../../../common/conditional";
import IsometricDrawing from "../../custom-utm/isometric-drawing";

import { ConcreteHammerData } from "../../../../utils/models";
import { getReportDetails } from "../../../../store/reportDetails";
import { getItemsChunkedData } from "../../../../utils/utilities";
import { TABLE_ITEM_COUNT_LIMITS } from "../../../../utils/constants";

interface Props {
    isVisible: boolean;
    item: ConcreteHammerData;
    title?: string;
    subtitle?: string;
}

const ConcreteHammerPDF: React.FC<Props> = ({ isVisible, item, title = "Inspection Findings", subtitle = "Concrete Hammer Test Report" }) => {
    const { itemCountPerPage } = useAppSelector(getReportDetails);
    
    const chunkedData = useMemo(() => {
        // If the readings are greater than the default count per page, chunk the first page by the default and render the others according to preference count.

        return getItemsChunkedData(item.reading.items, TABLE_ITEM_COUNT_LIMITS.CONCRETE, itemCountPerPage);
    }, [itemCountPerPage, item.reading.items]);

    return ( 
        <Conditional isVisible={isVisible}>
			<Conditional isVisible={item.locations.length > 0}>
                <IsometricDrawing label="Concrete Hammer Test Location"  isoImages={item.locations} />
            </Conditional>

            <Conditional isVisible={item.reading.items.length > 0}>
                {chunkedData.map((chunk, index) => (
                    <ConcreteHammerReportPDF
                        key={index}
                        sectionTitle={title}
                        sectionSubtitle={subtitle}
                        overview={item.overview}
                        data={chunk} 
                        startRange={item.reading.readingStartRange}
                        endRange={item.reading.readingEndRange}
                        shouldDisplayOverview={index === 0}
                        shouldDisplaySummary={index === (chunkedData.length - 1)}
                    />
                ))}
            </Conditional>
            
            <Conditional isVisible={item.reading.items.length === 0}>
                <ConcreteHammerReportPDF
                    sectionTitle={title}
                    sectionSubtitle={subtitle}
                    overview={item.overview}
                    data={[]} 
                    startRange={item.reading.readingStartRange}
                    endRange={item.reading.readingEndRange}
                    shouldDisplayOverview
                    shouldDisplaySummary
                />
            </Conditional>
        </Conditional>
     );
};
 
export default ConcreteHammerPDF;